import { useEffect, useState } from 'react';

import { Dialog } from '@reach/dialog';
import '@reach/dialog/styles.css';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { FaEllipsisH, FaTimes } from 'react-icons/fa';

export default function Modal({
    title,
    hideHeading = false,
    className,
    triggerClassName,
    trigger = <FaEllipsisH className="Icon Icon--primary" />,
    disabled = false,
    children,
    showDialogInitially = false,
    hideButton = false,
    hideCloseButton = false,
    onBeforeOpen = null,
    onClose = null,
}) {
    const [showDialog, setShowDialog] = useState(showDialogInitially);
    const close = () => {
        setShowDialog(false);
        if (typeof onClose === 'function') {
            onClose();
        }
    };

    const open = () => {
        if (typeof onBeforeOpen === 'function') {
            onBeforeOpen();
        }
        setShowDialog(true);
    };

    const handleClick = (event) => {
        event.stopPropagation();
    };

    useEffect(() => {
        if (showDialogInitially) {
            open();
        }
    }, [showDialogInitially]);

    const dismiss = (event) => {
        // Close if escape key was pressed, not if user clicked outside.
        if (!hideCloseButton && event.type === 'keydown') {
            close();
        }
    };

    return (
        <>
            {!hideButton && (
                <button
                    type="button"
                    className={classNames('Modal-trigger', triggerClassName)}
                    title={title}
                    onClick={open}
                    disabled={disabled}
                >
                    {trigger}
                </button>
            )}

            <Dialog
                className={classNames('Modal-dialog', className)}
                isOpen={showDialog}
                aria-label={title}
                onDismiss={dismiss}
                onMouseDown={handleClick}
                onMouseUp={handleClick}
                onMouseMove={handleClick}
                onMouseLeave={handleClick}
                onTouchStart={handleClick}
                onTouchEnd={handleClick}
                onTouchMove={handleClick}
                onTouchCancel={handleClick}
            >
                {!hideHeading && <h3 className="Modal-heading">{title}</h3>}

                {typeof children === 'function' ? children(close) : children}

                {!hideCloseButton && (
                    <button
                        type="button"
                        className="Modal-close"
                        onClick={close}
                    >
                        <FaTimes className="Modal-icon" />
                    </button>
                )}
            </Dialog>
        </>
    );
}

Modal.propTypes = {
    trigger: PropTypes.node.isRequired,
    title: PropTypes.string.isRequired,
    hideHeading: PropTypes.bool,
    className: PropTypes.string,
    triggerClassName: PropTypes.string,
    disabled: PropTypes.bool,
    children: PropTypes.oneOfType([
        PropTypes.arrayOf(PropTypes.node),
        PropTypes.node,
        PropTypes.func,
    ]),
    showDialogInitially: PropTypes.bool,
    hideButton: PropTypes.bool,
    hideCloseButton: PropTypes.bool,
    onBeforeOpen: PropTypes.func,
    onClose: PropTypes.func,
};
